import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import TooltipForReceptionist from 'components/TooltipForReceptionist';
import IN from 'constants/in';
import USER_ROLE from 'constants/role';
import { selectCurrentSalonBilling } from 'selectors/currentSalon.selectors';
import selectEffectiveUserRole from 'selectors/selectEffectiveUserRole';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import ListItem from 'settings/page-elements/dropdown/ListItem';
import Switcher from 'settings/page-elements/Switcher';

import CN from './DropdownList.module.scss';

class DropdownList extends React.Component {
  constructor(props) {
    super(props);
    const services = this.props.items;
    let isChecked = false;
    for (let i = 0; i < services.length; i += 1) {
      if (services[i].patch_test) {
        isChecked = true;
        break;
      }
    }
    this.state = {
      isChecked,
      patchToggleTime: 0,
      patchSwitchTime: 0,
    };
  }

  onCheckboxClick = (name, id, value) => {
    const seconds = new Date().getSeconds();
    const { patchToggleTime } = this.state;
    if (Math.abs(patchToggleTime - seconds) < 1) {
      return;
    }
    this.setState({ patchToggleTime: seconds });
    this.props.onCheckboxClick(name, id, value);
    const services = this.props.items;
    let isChecked = false;
    for (let i = 0; i < services.length; i += 1) {
      if (services[i].patch_test) {
        isChecked = true;
        break;
      }
    }
    this.setState({ isChecked });
  };

  onSwitcherClick = () => {
    const seconds = new Date().getSeconds();
    const { patchSwitchTime } = this.state;
    if (Math.abs(patchSwitchTime - seconds) < 1) {
      return;
    }
    this.setState({ patchSwitchTime: seconds });
    const { isChecked } = this.state;
    const services = this.props.items;
    for (let i = 0; i < services.length; i += 1) {
      this.props.onCheckboxClick(services[i].name, services[i].id, !isChecked, [services.length, i + 1]);
    }
    this.setState({ isChecked: !isChecked });
  };

  render() {
    const { hasBilling, showDescription, userRole } = this.props;

    const listItemsClasses = cn({
      [CN[`${this.props.variant}Variant`]]: this.props.variant,
    });

    return (
      <div data-bem="DropdownList" className={CN.component}>
        <div className={CN.listHeading}>
          <span className={CN.title}>{this.props.listName}</span>
          {this.props.showSwitcher && (
            <div className={CN.relative}>
              <Switcher isChecked={this.state.isChecked} checkId={this.props.listName} onCheckboxClick={!hasBilling ? alwaysNoop : () => this.onSwitcherClick()} />
              <TooltipForReceptionist where={IN.serviceSwitcher} />
            </div>
          )}
        </div>
        <div className={listItemsClasses}>
          {this.props.items.map((item) => (
            <div key={item.id} className={CN.item}>
              <ListItem
                itemName={item.name}
                id={item.id.toString()}
                description={showDescription && item.description}
                checked={item[this.props.childItemCheckPropName]}
                onCheckboxClick={userRole === USER_ROLE.receptionist ? alwaysNoop : this.onCheckboxClick}
                generalName={this.props.generalName}
              />
              <TooltipForReceptionist where={IN.serviceItem} />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  hasBilling: selectCurrentSalonBilling(state),
  userRole: selectEffectiveUserRole(state),
});

const DropdownListHoc = connect(mapStateToProps)(DropdownList);

export default DropdownListHoc;
